import { AuthManager, Role } from "@cuatroochenta/co-admin-react-library";
import { CreateAlbumRequest, EditAlbumRequest } from "../model/data/album";
import { Album, AlbumDetail } from "../model/domain/album";
import TaskBase from "./TaskBase";
import Urls from "./Urls";

export default class TaskAlbums extends TaskBase {

    public getAlbums() {
        return fetch(`${Urls.URL_GET_ALBUMS}?center_id=${this.selectedCenter}&role_id=${Role.ADMIN}`, this.getRequestInfo())
            .then(response => response.json())
            .then(data => {
                return data;
            })
            .catch(error => {
                console.error('Error fetching albums:', error);
                throw error;
            });
    }

    public getAlbumDetail(albumId: number): Promise<AlbumDetail> {
        return fetch(`${Urls.URL_GET_ALBUMS}/${albumId}`, this.getRequestInfo())
            .then(response => response.json())
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error('Error fetching albums:', error);
                throw error;
            });
    }

    public getAlbumCoverUrl(album: Album) {
        return `${Urls.URL_GET_IMAGES}/${album.coverId}?token=${AuthManager.getAuthToken()}`
    }

    public async createAlbum(postContent: CreateAlbumRequest) {
        const url = Urls.URL_GET_ALBUMS;
        const formData = new FormData();
    
        formData.append('title', postContent.title);
        formData.append('shareOptions', JSON.stringify(postContent.shareOptions));
        formData.append('is_for_all_centers', postContent.isForAllCenters);
        
        if (postContent.media) {
            postContent.media.forEach((file, index) => {
                formData.append(`media[${index}]`, file);
            });
        } else {
          formData.append('media[]', new Blob([]));
        }

        const requestInfo = {
            ...this.getRequestInfo(),
            method: 'POST',
            body: formData,
            headers: {
                ...this.getRequestInfo().headers,
            }
        };
    
        return fetch(url, requestInfo)
            .then(response => {
                if (!response.ok) {
                    return response.json().then((data) => {
                        throw new Error(data.message || 'Error al crear el álbum');
                    });
                }
                return response.json();
            })
            .then(data => {
                console.log('Álbum creado con éxito:', data);
                return data;
            })
            .catch(error => {
                console.error('Error al crear el álbum:', error);
                throw error;
            });
    }

    public async editAlbum(id: number, postContent: EditAlbumRequest) {
        const url = `${Urls.URL_GET_ALBUMS}/${id}`;
        const formData = new FormData();

        formData.append('title', postContent.title);
        formData.append('is_for_all_centers', postContent.isForAllCenters ? 'true' : 'false');
        formData.append('shareOptions', JSON.stringify(postContent.shareOptions));

        if (postContent.media) {
            postContent.media.forEach((file, index) => {
                formData.append(`media[${index}]`, file);
            });
        }

        const requestInfo = {
            ...this.getRequestInfo(),
            method: 'POST',
            body: formData,
            headers: {
                ...this.getRequestInfo().headers,
            }
        };

        return fetch(url, requestInfo)
            .then(response => {
                if (!response.ok) {
                    return response.json().then((data) => {
                        throw new Error(data.message || 'Error al editar el álbum');
                    });
                }
                return response.json();
            })
            .then(data => {
                console.log('Álbum editado con éxito:', data);
                return data;
            })
            .catch(error => {
                console.error('Error al editar el álbum:', error);
                throw error;
            });
    }

    public removeAlbum(albumId: number) {
        const url = `${Urls.URL_GET_ALBUMS}/${albumId}`;

        const requestInfo = {
            ...this.getRequestInfo(),
            method: 'DELETE',
        };

        return fetch(url, requestInfo)
            .then(response => {
                if (!response.ok) {
                    return response.json().then((data) => {
                        throw new Error(data.message || 'Error al eliminar el álbum');
                    });
                }
                return response.json();
            })
            .then(data => {
                console.log('Álbum eliminado con éxito:', data);
                return data;
            })
            .catch(error => {
                console.error('Error al eliminar el álbum:', error);
                throw error;
            });
    }

    public removeMedia(albumId: number, mediaId: number): Promise<any> {
        const url = `${Urls.URL_GET_ALBUMS}/${albumId}/media/${mediaId}`;

        console.log("mediaId: " + mediaId);
        console.log("url: " + url);

        const requestInfo = {
            ...this.getRequestInfo(),
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                ...this.getRequestInfo().headers,
            }
        };

        return fetch(url, requestInfo)
            .then(response => {
                if (!response.ok) {
                    return response.json().then((data) => {
                        throw new Error(data.message || 'Error al eliminar el medio');
                    });
                }
                return response.json();
            })
            .then(data => {
                console.log('Medio eliminado con éxito:', data);
                return data;
            })
            .catch(error => {
                console.error('Error al eliminar el medio:', error);
                throw error;
            });
    }

}